import { apiClient } from '@/api/client';
import type { Rating } from '@/types/rating';
import { mapRatingWireToDomain } from '../mappers/rating';
import { RatingWire, ratingsListResponseSchema } from '../schemas/rating';

/**
 * Domain-oriented API module for rating operations
 * Provides typed functions for fetching menu item ratings from the Gateway API
 */

/**
 * Get all menu item ratings
 *
 * @returns List of all available ratings
 *
 * @example
 * ```typescript
 * const ratings = await getRatings();
 * // Returns: [
 * //   { id: 1, key: 'must_try', label: 'Must Try' },
 * //   { id: 2, key: 'try_it', label: 'Try It' },
 * //   { id: 3, key: 'its_ok', label: "It's OK" },
 * //   { id: 4, key: 'skip_it', label: 'Skip It' }
 * // ]
 * ```
 */
export async function getRatings(): Promise<Rating[]> {
  const endpoint = '/api/menu-item-ratings';
  const wireData = await apiClient.get<RatingWire[]>(endpoint);

  // Validate wire response, then map each item to the domain type
  const validated = ratingsListResponseSchema.parse(wireData);
  return validated.map(mapRatingWireToDomain);
}
